import React from 'react'
import NewEditApplication from '../modules/NewEditApplication/NewEditApplication'

const NewApplication: React.FC = () => {
  return <NewEditApplication />
}

export default NewApplication
